import { z } from 'zod'

import { OrgAIUsageLedgerStatus } from '../constants/aiUsageLedger'
import { dbEntitySchema } from './system'

export const orgAIUsageLedgerSchema = dbEntitySchema.extend({
  organization: z.string(),
  venue: z.string().optional(),
  managementUser: z.string().optional(),
  feature: z.string(),
  requestId: z.string(),
  model: z.string(),
  promptVersion: z.string().optional(),
  tokensIn: z.number().optional(),
  tokensOut: z.number().optional(),
  costUsd: z.number().optional(),
  aiActions: z.number().optional(),
  status: z.nativeEnum(OrgAIUsageLedgerStatus),
  errorCode: z.string().optional(),
  generatedText: z.string().optional(),
})

export const orgAIUsageLedgerCreateArgsSchema = orgAIUsageLedgerSchema
  .pick({
    feature: true,
    requestId: true,
    model: true,
    promptVersion: true,
    tokensIn: true,
    tokensOut: true,
    costUsd: true,
    aiActions: true,
    status: true,
    errorCode: true,
    generatedText: true,
  })
  .extend({
    organizationId: z.string(),
    venueId: z.string().optional(),
    managementUserId: z.string().optional(),
  })

export const orgAIUsageLedgerRequestIdSchema = z.string().min(1)

export const orgAIUsageLedgerMonthSchema = z.string().regex(/^\d{4}-\d{2}$/)

export const orgAIUsageLedgerListRequestSchema = z.object({
  month: orgAIUsageLedgerMonthSchema.optional(),
  skip: z.coerce.number().min(0).optional(),
  limit: z.coerce.number().min(0).optional(),
  sort: z.string().optional().nullable(),
})

export const orgAIUsageLedgerListArgsSchema = z.object({
  organizationId: z.string(),
  month: orgAIUsageLedgerMonthSchema.optional(),
  skip: z.coerce.number().min(0).optional(),
  limit: z.coerce.number().min(0).optional(),
  sort: z.string().optional().nullable(),
})

export const orgAIUsageLedgerListResponseSchema = z.object({
  data: z.array(orgAIUsageLedgerSchema),
})

export const orgAIUsageLedgerSummaryResponseSchema = z.object({
  usedAiActionsThisMonth: z.number(),
  includedAiActionsPerMonth: z.number(),
  periodStartsAt: z.string(),
  periodEndsAt: z.string(),
})
